module.exports = __webpack_public_path__ + "static/media/logo-white.30cab7b8.svg";